import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
// import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  makeStyles,
  IconButton,
  Avatar,
  Typography,
  Tooltip,
  Collapse,
  Menu,
  MenuItem,
  Button,
  Select as Seletor,
  FormControl,
  InputLabel,
} from '@material-ui/core';
import {
  faCheckSquare,
  faExclamationCircle,
  faFileDownload,
  faFileImage,
  faFilePdf
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Delete,
  Edit,
  RateReview,
  ExpandMore,
  ExpandLess,
  Visibility,
  VisibilityOff
} from '@material-ui/icons/';
import getInitials from 'src/utils/getInitials';
import { green, grey } from '@material-ui/core/colors';
import Toolbar from './Toolbar';

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    marginRight: theme.spacing(2)
  },
  reprovado: {
    color: 'red',
    fontSize: '30px',
    display: 'block',
    margin: '0 auto'
  },
  icon: {
    color: grey[500],
    fontSize: '30px',
    display: 'block',
    margin: '0 auto'
  },
  aprovado: {
    color: green[500],
    fontSize: '30px',
    display: 'block',
    margin: '0 auto'
  },
  center: {
    textAlign: 'center'
  },
  esconder: {
    display: 'none',
  },
  awesome: {
    color: 'rgba(0, 0, 0, 0.54)',
  },
  label: {
    backgroundColor: 'white'
  }
}));

const Tabela = ({
  className,
  estrutura,
  data,
  edit,
  exportar,
  remove,
  busca,
  filtros,
  revisar,
  exibir,
  button,
  select,
  placeholder,
  minWidth = 1050,
  limite = 10,
  rowsPerPageOptions = [5, 10, 25, 50, 100],
  ...rest
}) => {
  const classes = useStyles();
  const [limit, setLimit] = useState(limite);
  const [page, setPage] = useState(0);
  const [expandir, setExpandir] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    console.log(newPage);
    setPage(newPage);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEpandir = (exp) => {
    if (expandir !== null) {
      setExpandir(null);
    } else {
      setExpandir(exp);
    }
  };

  console.log(data);

  const tabela = (dados) => {
    const mapeados = dados.map((d) => {
      const colunas = [];
      const acoes = [];
      Object.entries(d).forEach(([key, value]) => {
        const { id } = d;
        if (key !== 'id' && key !== 'delete' && key !== 'edit' && key !== 'revisar' && key !== 'expandir' && key !== 'exportar' && key !== 'exibir') {
          if (value.tipo === 'avatar') {
            colunas.push(
              <TableCell key={key}>
                <Box
                  alignItems="center"
                  display="flex"
                >
                  <Avatar
                    className={classes.avatar}
                    src={value.avatar}
                  >
                    {getInitials(value.conteudo)}
                  </Avatar>
                  <Typography
                    color="textPrimary"
                    variant="body1"
                  >
                    {value.conteudo}
                  </Typography>
                </Box>
              </TableCell>
            );
          } else if (value.tipo === 'status') {
            let icone;
            switch (value.conteudo) {
              case 'Aprovado':
                icone = (
                  <FontAwesomeIcon
                    icon={faCheckSquare}
                    className={classes.aprovado}
                  />
                );
                break;
              case 'Em Revisão':
                icone = (
                  <FontAwesomeIcon
                    icon={faCheckSquare}
                    className={classes.icon}
                  />
                );
                break;
              case 'Reprovado':
                icone = (
                  <FontAwesomeIcon
                    icon={faExclamationCircle}
                    className={classes.reprovado}
                  />
                );
                break;
              default:
                break;
            }
            colunas.push(
              <TableCell key={key}>
                <Tooltip title={value.conteudo}>
                  {icone}
                </Tooltip>
              </TableCell>
            );
          } else {
            colunas.push(
              <TableCell key={key}>
                {value.conteudo}
              </TableCell>
            );
          }
        }
        if (key === 'delete' && value === true) {
          acoes.push(
            <Tooltip title="Remover">
              <IconButton
                onClick={() => remove(id)}
              >
                <Delete />
              </IconButton>
            </Tooltip>
          );
        }
        if (key === 'edit' && value === true) {
          acoes.push(
            <Tooltip title="Editar">
              <IconButton
                onClick={() => edit(id)}
              >
                <Edit />
              </IconButton>
            </Tooltip>
          );
        }
        if (key === 'revisar' && value === true) {
          acoes.push(
            <Tooltip title="Revisar">
              <IconButton
                onClick={() => revisar(id)}
              >
                <RateReview />
              </IconButton>
            </Tooltip>
          );
        }
        if (key === 'exibir') {
          colunas.push(
            <TableCell key={key}>
              <Tooltip title="Exibir">
                <IconButton
                  onClick={() => exibir(id)}
                >
                  {value.conteudo ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </Tooltip>
            </TableCell>
          );
        }
        if (key === 'button') {
          colunas.push(
            <TableCell>
              <Tooltip title="Exibir">
                <Button
                  key={key}
                  onClick={() => button(id)}
                >
                  {value.conteudo}
                </Button>
              </Tooltip>
            </TableCell>

          );
        }
      });
      colunas.push(<TableCell>{acoes}</TableCell>);
      return (
        <>
          <TableRow
            hover
            key={d.id}
          >
            {colunas}
          </TableRow>
        </>
      );
    });
    return mapeados;
  };
  const inicio = (page > 0 ? (page * limit) : 0);
  let fim = 0;
  if (page === 0) {
    fim = limit;
  } else if (page === 1) {
    fim = limit * 2;
  } else {
    fim = limit * (page + 1);
  }
  console.log('Início', inicio);
  console.log('Fim', fim);
  const listagem = data.slice(inicio, fim);
  console.log('Listagem', listagem);
  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <PerfectScrollbar>
        <Box minWidth={minWidth}>
          {placeholder && (
            <Toolbar busca={busca} placeholder={placeholder} filtros={filtros} />
          )}
          <Table>
            <TableHead>
              <TableRow>
                {estrutura.map((coluna) => (
                  <TableCell
                    size={coluna.size !== undefined ? coluna.size : 'medium'}
                    className={coluna.center ? classes.center : ''}
                    key={coluna.id}
                  >
                    {coluna.nome}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {listagem.map((d) => {
                const colunas = [];
                const acoes = [];
                let subtabela = [];
                const { id } = d;
                Object.entries(d).forEach(([key, value]) => {
                  if (key !== 'id' && key !== 'delete' && key !== 'edit' && key !== 'revisar' && key !== 'subtabela' && key !== 'exportar' && key !== 'exibir' && key !== 'mapa') {
                    if (value.tipo === 'avatar') {
                      colunas.push(
                        <TableCell key={key}>
                          <Box
                            alignItems="center"
                            display="flex"
                          >
                            <Avatar
                              className={classes.avatar}
                              src={value.avatar}
                            >
                              {getInitials(value.conteudo)}
                            </Avatar>
                            <Typography
                              color="textPrimary"
                              variant="body1"
                            >
                              {value.conteudo}
                            </Typography>
                          </Box>
                        </TableCell>
                      );
                    } else if (value.tipo === 'status') {
                      let icone;
                      switch (value.conteudo) {
                        case 'Aprovado':
                          icone = (
                            <FontAwesomeIcon
                              icon={faCheckSquare}
                              className={classes.aprovado}
                            />
                          );
                          break;
                        case 'Em Revisão':
                          icone = (
                            <FontAwesomeIcon
                              icon={faCheckSquare}
                              className={classes.icon}
                            />
                          );
                          break;
                        case 'Reprovado':
                          icone = (
                            <FontAwesomeIcon
                              icon={faExclamationCircle}
                              className={classes.reprovado}
                            />
                          );
                          break;
                        default:
                          break;
                      }
                      colunas.push(
                        <TableCell key={key}>
                          <Tooltip title={value.conteudo}>
                            {icone}
                          </Tooltip>
                        </TableCell>
                      );
                    } else if (value.tipo === 'button') {
                      colunas.push(
                        <TableCell key={key}>
                          <Tooltip title={value.dica}>
                            <Button
                              key={key}
                              onClick={() => button(id)}
                            >
                              {value.conteudo}
                            </Button>
                          </Tooltip>
                        </TableCell>
                      );
                    } else if (value.tipo === 'select') {
                      colunas.push(
                        <TableCell key={key}>
                          <Tooltip title={value.dica}>
                            <FormControl
                              variant="outlined"
                            >
                              <InputLabel shrink className={classes.label} fullWidth>{select.label}</InputLabel>
                              <Seletor
                                value={value.conteudo}
                                fullWidth
                                onChange={(event) => select.onChange(event, value.id)}
                              >
                                {select.options.map((op) => (
                                  <MenuItem value={op.id}>{op.label}</MenuItem>
                                ))}
                              </Seletor>
                            </FormControl>
                          </Tooltip>
                        </TableCell>
                      );
                    } else {
                      colunas.push(
                        <TableCell key={key}>
                          {value.conteudo}
                        </TableCell>
                      );
                    }
                  }
                  if (key === 'mapa') {
                    colunas.push(
                      <TableCell key={key}>
                        <Tooltip title={value.dica}>
                          <Button
                            key={key}
                            disabled={value.mapa === undefined}
                            onClick={() => button(id)}
                          >
                            {value.conteudo}
                          </Button>
                        </Tooltip>
                      </TableCell>
                    );
                  }
                  if (key === 'delete' && value === true) {
                    acoes.push(
                      <Tooltip title="Remover">
                        <IconButton
                          onClick={() => remove(id)}
                        >
                          <Delete />
                        </IconButton>
                      </Tooltip>
                    );
                  }
                  if (key === 'edit' && value === true) {
                    acoes.push(
                      <Tooltip title="Editar">
                        <IconButton
                          onClick={() => edit(id)}
                        >
                          <Edit />
                        </IconButton>
                      </Tooltip>
                    );
                  }
                  if (key === 'revisar' && value === true) {
                    acoes.push(
                      <Tooltip title="Revisar">
                        <IconButton
                          onClick={() => revisar(id)}
                        >
                          <RateReview />
                        </IconButton>
                      </Tooltip>
                    );
                  }
                  if (key === 'exportar' && value === true) {
                    acoes.push(
                      <>
                        <Tooltip title="Exportar">
                          <IconButton
                            onClick={handleClick}
                            aria-haspopup="true"
                            aria-controls="simple-menu"
                          >
                            <FontAwesomeIcon
                              icon={faFileDownload}
                            />
                          </IconButton>
                        </Tooltip>
                        <Menu
                          id="simple-menu"
                          anchorEl={anchorEl}
                          keepMounted
                          open={Boolean(anchorEl)}
                          onClose={handleClose}
                        >
                          <MenuItem onClick={() => exportar(id, 'jpeg')}>
                            <FontAwesomeIcon
                              icon={faFileImage}
                              className={classes.awesome}
                            />
                            .JPEG
                          </MenuItem>
                          <MenuItem onClick={() => exportar(id, 'png')}>
                            <FontAwesomeIcon
                              icon={faFileImage}
                              className={classes.awesome}
                            />
                            .PNG
                          </MenuItem>
                          <MenuItem onClick={() => exportar(id, 'pdf')}>
                            <FontAwesomeIcon
                              icon={faFilePdf}
                              className={classes.awesome}
                            />
                            .PDF
                          </MenuItem>
                        </Menu>
                      </>
                    );
                  }
                  if (key === 'exibir') {
                    if (value.pode) {
                      colunas.push(
                        <TableCell key={key}>
                          <Tooltip title="Exibir">
                            <IconButton
                              onClick={() => exibir(id)}
                            >
                              {value.conteudo ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      );
                    }
                  }
                  if (key === 'subtabela' && value.length > 0) {
                    colunas.push(
                      <TableCell key={key}>
                        <Tooltip title={expandir !== id ? 'Expandir subcategorias' : 'Esconder subcategorias'}>
                          <IconButton
                            size="small"
                            aria-label="expand row"
                            onClick={() => handleEpandir(id)}
                          >
                            {expandir !== id ? <ExpandMore /> : <ExpandLess />}
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    );
                    subtabela = value;
                  }
                });
                colunas.push(<TableCell>{acoes}</TableCell>);
                const estruturadois = estrutura.slice(1);
                return (
                  <>
                    <TableRow
                      hover
                      key={d.id}
                    >
                      {colunas}
                    </TableRow>
                    {subtabela.length > 0 && (
                      <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={estrutura.length}>
                          <Collapse in={id === expandir} timeout="auto" unmountOnExit>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  {estruturadois.map((coluna) => (
                                    <TableCell className={coluna.center ? classes.center : ''} key={coluna.id}>
                                      {coluna.nome}
                                    </TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {tabela(subtabela)}
                              </TableBody>
                            </Table>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    )}
                  </>
                );
              })}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={data.length}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={rowsPerPageOptions}
      />
    </Card>
  );
};

Tabela.propTypes = {
  className: PropTypes.string,
  filtros: PropTypes.array,
  data: PropTypes.array.isRequired
};

export default Tabela;
